import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, IconButton, Menu, MenuItem as MUIMenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import type { MouseEvent } from 'react';
import { useMemo, useState } from 'react';
import { Analytics } from '@/shared/lib';
import { DefaultPresetMenuItem } from '../DefaultPresetMenuItem/DefaultPresetMenuItem';
import { useSavedPresetsContext } from '../SavedPresetsContext/SavedPresetsContext';

const MenuItem = styled(MUIMenuItem)(({ theme }) => ({
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
}));

interface Props {
  presetId: string;
}

export function SharedSavedPresetMenu({ presetId }: Props) {
  const { presets, updatePreset } = useSavedPresetsContext();
  const preset = useMemo(() => {
    return presets.find((p) => p.id === presetId);
  }, [presets, presetId]);
  const isFavorite = preset?.isFavorite;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (event: MouseEvent) => {
    event.stopPropagation();
    setAnchorEl(null);
  };
  const handleToggleFavorite = () => {
    updatePreset(presetId, {
      isFavorite: !isFavorite,
      updateContent: false,
    });
    Analytics.sendFeatureUsage(
      'saved_presets',
      isFavorite ? 'unfavorite_preset' : 'favorite_preset',
    );
  };

  return (
    <Box>
      <IconButton size="small" onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        MenuListProps={{
          sx: { p: 0 },
        }}
        anchorEl={anchorEl}
        open={open}
        transformOrigin={{ horizontal: 'left', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        onClose={handleClose}
        onClick={handleClose}
      >
        <MenuItem onClick={handleToggleFavorite}>
          {isFavorite ? 'Remove from favorites' : 'Add to favorites'}
        </MenuItem>
        <DefaultPresetMenuItem presetId={presetId} />
      </Menu>
    </Box>
  );
}
